import { render, staticRenderFns } from "./LoggerList.vue?vue&type=template&id=79984d19&"
import script from "./LoggerList.vue?vue&type=script&lang=js&"
export * from "./LoggerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports